import script from "./Pane8.vue?vue&type=script&setup=true&lang=js"
export * from "./Pane8.vue?vue&type=script&setup=true&lang=js"

import "./Pane8.vue?vue&type=style&index=0&id=01f3ad97&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f3ad97"]])

export default __exports__